module.exports = __webpack_public_path__ + "img/certificate.1e5778a8.png";